export const NO_PROJECT_ACCESS_URL = 'access-denied';
